class UnsafeFilter {

  $inject = ["$sce"];

  /*@ngInject*/
  static instance() { //static instance function
    let dataFilter = ["$sce", $sce => {
      let filteredObject = (input) => {
        //filter logic
        return $sce.trustAsHtml(input);
      }
      return filteredObject;
    }]
    return dataFilter;
  }
}

export default UnsafeFilter;
